export const isValidEmailAddress = (emailAddress) => {
    emailAddress = emailAddress.trim();
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(emailAddress);
};


export const validateRequiredFields = (data, requiredFields) => {
    const validationErrors = {};

    requiredFields.forEach((field) => {
        let errorMessage = {};

        if (!data[field]) {
            // Ensure errorMessage is always an object

            switch (field) {
                case "title":
                    errorMessage[field] = "Name field is required.";
                    break;
                default:
                    errorMessage[field] = `${field.replace("_", " ").charAt(0).toUpperCase()}${field.replace("_", " ").slice(1)} field is mandatory.`;
            }

            validationErrors[field] = {
                message: errorMessage[field],
            };
        } else if (field === 'name' || field === 'email') {
            let trim;
            trim = data[field].trim();

            if (trim === "") {
                errorMessage[field] = "Field cannot be empty.";
                validationErrors[field] = {
                    message: errorMessage[field],
                };
            }
        }
        // else if (field === 'contact_number') {
        //     const phoneValue = data[field];
        //     if (phoneValue.length < 10 || phoneValue.length > 13) {
        //         errorMessage[field] = "please enter a valid phone number.";
        //         validationErrors[field] = {
        //             message: errorMessage[field],
        //         };
        //     }
        // }
    });

    // Check if passwords match
    if (data['password'] !== data['confirm_pass']) {
        validationErrors['confirm_pass'] = {
            message: 'Passwords do not match.',
        };
    }

    return validationErrors;
};

export const getFormatedTime = (time) => {
    const hours = time.$d.getHours();
    const minutes = time.$d.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;

    return formattedTime;
}